import {ActionTree, GetterTree, MutationTree} from 'vuex';
import QuestionArray from '@/components/Question/QuestionArray';
import Question from '@/components/Question/Question';
import {client} from '@/components/api';
import ThemeArray from '@/components/Theme/ThemeArray';
import Theme from '@/components/Theme/Theme';

const TICKET_URL: string = '/ticket';
const THEME_URL: string = '/theme';
const EXAM_URL: string = '/exam';

interface State {
    items: QuestionArray;
    isExam: boolean;
    inProgress: boolean;
}

const state: State = {
    items: new QuestionArray(),
    isExam: false,
    inProgress: false,
};

const getters: GetterTree<State, any> = {
    questions: (state) => state.items,
    isExam: (state) => state.isExam,
    inProgress: (state) => state.inProgress,
};

const mutations: MutationTree<State> = {
    addQuestion(state, item: Question) {
        state.items.add(item);
    },
    fillQuestions(state, items: Question[]) {
        state.items.refresh(items);
    },

    resetQuestions(state) {
        state.items.clear();
    },

    addAdditionalQuestions(state, payload: Question[]) {
        state.items.merge(payload);
    },
    startExam(state) {
        state.isExam = true;
    },
    finishExam(state) {
        state.isExam = false;
    },

    startTest(state) {
        state.inProgress = true;
    },
    finishTest(state) {
        state.inProgress = false;
    },

};

const actions: ActionTree<State, any> = {
    getTicketQuestions({commit}, id: number) {
        commit('resetQuestions');

        client.get(TICKET_URL + '/' + id).then((response) => {
            const payload: Question[] = response && response.data;
            commit('fillQuestions', payload);
        }, (error) => {
            throw Error(`getTicketQuestions error: ${error}`);
        });
    },

    getThemeQuestions({commit}, id: number) {
        commit('resetQuestions');

        client.get(THEME_URL + '/' + id).then((response) => {
            const payload: Question[] = response && response.data;
            commit('fillQuestions', payload);
        }, (error) => {
            throw Error(`getThemeQuestions error: ${error}`);
        });
    },

    async getAdditionalQuestions({commit}, themes: number[]) {
        for (const item of themes) {
            await client.get(THEME_URL + '/' + item).then((response) => {
                const payload: Question[] = response && response.data;

                commit('addAdditionalQuestions', payload);
            }, (error) => {
                throw Error(`getAdditionalQuestions error: ${error}`);
            });
        }
    },

    getExamQuestions({commit}) {
        commit('resetQuestions');

        client.get(EXAM_URL).then((response) => {
            const payload: Question[] = response && response.data.questions;
            commit('fillQuestions', payload);
            const themes: Theme[] = response.data.themes;
            commit('setExamThemes', themes);
        }, (error) => {
            throw Error(`getExamQuestions error: ${error}`);
        });
    },
};

export const questions = {
    state,
    getters,
    mutations,
    actions,
};

